import {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControl from '../components/customizedInputs/TextControl';
import { PDFDocument } from 'pdf-lib';
import pdfVacio from '../assets/pdf/declaracion-pdf.pdf';
import DiferenciasDeclaracionJurada from '../components/DiferenciasDeclaracionJurada';

const DeclaracionJuradaForm = () => {
  let { id } = useParams();
  const [usuario, setUsuario] = useState();
  const [saving, setSaving] = useState(false);
  const [step, setStep] = useState(3);

  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [registroPdf, setRegistroPdf] = useState({})
  const [pdfUrl, setPdfUrl] = useState(null);
  const [adjunto, setAdjunto] = useState(null);
  const [resource, setResource] = useState({});

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
      fetchDeclaracionJurada()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchDeclaracionJurada = async () => {
    try {
      const data = await resourcesServices.nuevoResource('declaraciones_juradas');

      setResource(data);
    } catch (error) {
      errorMessage(error)
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setAdjunto(files[0])
  };

  const guardarDeclaracionJurada = async () => {
    try {
      setSaving(true)
      console.log(resource)
      // const newObject = {...camposBasicos, ...camposDomicilioReal, ...camposDomicilioLegal, ...datosUsuario}

      const attributeName = 'declaracion_jurada'
      const formData =  new FormData();
      for(const [key, value] of Object.entries(resource)){
        if(value){
          formData.append(`${attributeName}[${key}]`, value || '')
        }
      }

      if(adjunto){
        formData.append(`${attributeName}[adjunto]`, adjunto)
      }

      console.log(formData)
      await resourcesServices.crearResource('declaraciones_juradas', formData);

      setSaving(false)
      navigate(`/`);

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };


  const generatePdf = async (declaracion_jurada) => {
    const fecha = new Date();
    const hoy = fecha.getDate();
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    const dias = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
    const mesActual = fecha.getMonth();
    const diaActual = fecha.getDay();

    const fromBytes = await fetch(pdfVacio).then((res) => res.arrayBuffer());

    // Load the PDF with form fields
    const pdfDoc = await PDFDocument.load(fromBytes);

    const form = pdfDoc.getForm();

    const fieldFechaActual = form.getTextField('fecha_actual')

    fieldFechaActual.setText(`${dias[diaActual]}, ${String(hoy)} de ${meses[mesActual]} de ${fecha.getFullYear()}`)
    fieldFechaActual.enableReadOnly();

    if(declaracion_jurada && declaracion_jurada.usuario){

      // FECHA DE NACIMIENTO
      const [ ano, mes, dia ] = (declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.f_nacimiento || '2000-1-1').split("-")
      const fieldNacimD = form.getTextField('nacim_d')
      const fieldNacimM = form.getTextField('nacim_m')
      const fieldNacimA = form.getTextField('nacim_a')

      fieldNacimD.setText(dia)
      fieldNacimM.setText(mes)
      fieldNacimA.setText(ano)

      fieldNacimD.enableReadOnly();
      fieldNacimM.enableReadOnly();
      fieldNacimA.enableReadOnly();

      // NOMBRE
      const nombre = form.getTextField('nombre')
      nombre.setText( declaracion_jurada.usuario.nombre || '' )
      nombre.enableReadOnly();

      // APELLIDO
      const apellido = form.getTextField('apellido')
      apellido.setText( declaracion_jurada.usuario.apellido || '' )
      apellido.enableReadOnly();

      // TIPO DOCUMENTO
      const fieldTipoDocumento = form.getTextField('tipo_doc')
      fieldTipoDocumento.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.tipo_doc || '' )
      fieldTipoDocumento.enableReadOnly();

      // DOCUMENTO
      const fieldDocumento = form.getTextField('documento')
      fieldDocumento.setText( declaracion_jurada.usuario.documento_identidad || '' )
      fieldDocumento.enableReadOnly();

      // NACIONALIDAD
      const fieldNacionalidad = form.getTextField('nacionalidad')
      fieldNacionalidad.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.nacionalidad || '' )
      fieldNacionalidad.enableReadOnly();

      // TELEFONO PARTICULAR
      const fieldTelefonoParticular = form.getTextField('telefono_particular')
      fieldTelefonoParticular.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.telefono_particular || '' )
      fieldTelefonoParticular.enableReadOnly();

      // TELEFONO LABORAL
      const fieldTelefonoLaboral = form.getTextField('telefono_laboral')
      fieldTelefonoLaboral.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.telefono_laboral || '' )
      fieldTelefonoLaboral.enableReadOnly();

      // ESTADO CIVIL
      const fieldEstadoCivil = form.getTextField('estado_civil')
      fieldEstadoCivil.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.estado_civil || '' )
      fieldEstadoCivil.enableReadOnly();

      // NOMBRE CONYUGE
      const fieldNombreConyuge = form.getTextField('nombre_conyuge')
      fieldNombreConyuge.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.nombre_conyuge || '' )
      fieldNombreConyuge.enableReadOnly();

      // APELLIDO CONYUGE
      const fieldApellidoConyuge = form.getTextField('apellido_conyuge')
      fieldApellidoConyuge.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.apellido_conyuge || '' )
      fieldApellidoConyuge.enableReadOnly();

      // CARGO
      const fieldCargo1 = form.getTextField('cargo1')
      fieldCargo1.setText( '' )

      const fieldCargo2 = form.getTextField('cargo2')
      fieldCargo2.setText(declaracion_jurada.cargo || '')

      fieldCargo1.enableReadOnly();
      fieldCargo2.enableReadOnly();
      
      // ORGANISMO
      const fieldOrganismo = form.getTextField('organismo')
      fieldOrganismo.setText( declaracion_jurada.organismo || '' )
      fieldOrganismo.enableReadOnly();
      
      // FECHA CARGO DESDE
      const fieldFecha = form.getTextField('cargo_desde')
      fieldFecha.setText( declaracion_jurada.f_cargo_desde || '' )
      fieldFecha.enableReadOnly();

      // FECHA CARGO HASTA
      const fieldFechaHasta = form.getTextField('cargo_hasta')
      fieldFechaHasta.setText( declaracion_jurada.f_cargo_hasta || '' )
      fieldFechaHasta.enableReadOnly();

      // NUMERO NORMA LEGAL ALTA
      const fieldNormaLegalAlta = form.getTextField('numero_alta_norma_legal')
      fieldNormaLegalAlta.setText( declaracion_jurada.numero_alta_norma_legal || '' )
      fieldNormaLegalAlta.enableReadOnly();

      // NUMERO NORMA LEGAL BAJA
      const fieldNormaLegalBaja = form.getTextField('numero_baja_norma_legal')
      fieldNormaLegalBaja.setText( declaracion_jurada.numero_baja_norma_legal || '' )
      fieldNormaLegalBaja.enableReadOnly();    

      // EMAIL
      const textEmail = form.getTextField('email')
      textEmail.setText( declaracion_jurada.usuario.email || '' );
      textEmail.enableReadOnly();



      // CALLE DOMICILIO REAL
      const textCalleReal = form.getTextField('calle_real')
      textCalleReal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.calle_real || '' );
      textCalleReal.enableReadOnly();

      // BARRIO DOMICILIO REAL
      const textBarrioReal = form.getTextField('barrio_real')
      textBarrioReal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.barrio_real || '' );
      textBarrioReal.enableReadOnly();

      // LOCALIDAD DOMICILIO REAL
      const textLocalidadReal = form.getTextField('localidad_real')
      textLocalidadReal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.localidad_real || '' );
      textLocalidadReal.enableReadOnly();

      // CODIGO POSTAL DOMICILIO REAL
      const fieldCpReal = form.getTextField('codigo_postal_real')
      fieldCpReal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.cp_real || '' );
      fieldCpReal.enableReadOnly();



      // CALLE DOMICILIO LEGAL
      const textCalleLegal = form.getTextField('calle_legal')
      textCalleLegal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.calle_legal || '' );
      textCalleLegal.enableReadOnly();

      // BARRIO DOMICILIO LEGAL
      const textBarrioLegal = form.getTextField('barrio_legal')
      textBarrioLegal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.barrio_legal || '' );
      textBarrioLegal.enableReadOnly();

      // LOCALIDAD DOMICILIO LEGAL
      const textLocalidadLegal= form.getTextField('localidad_legal')
      textLocalidadLegal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.localidad_legal || '' );
      textLocalidadLegal.enableReadOnly();

      // CODIGO POSTAL DOMICILIO LEGAL
      const fieldCpLegal = form.getTextField('codigo_postal_legal')
      fieldCpLegal.setText( declaracion_jurada.usuario.preferencias_usuario && declaracion_jurada.usuario.preferencias_usuario.cp_legal || '' );
      fieldCpLegal.enableReadOnly();

    }
    

    const pdfBytes = await pdfDoc.save();

    // Convertir el array de bytes a un Blob
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

    // Crear un objeto URL para mostrar el PDF
    const pdfUrl = URL.createObjectURL(pdfBlob);

    setPdfUrl(pdfUrl);
  }


  const validarCampos = async () => {
    try {
      setSaving(true)

      const data = await resourcesServices.crearResource('declaraciones_juradas/validarContenido', {declaracion_jurada: resource}, false);

      setSaving(false)
      alert("Datos Validos")
      await generatePdf(data)

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(window.confirm('Está seguro que quiere crear una nueva declaracion jurada?')) {
      guardarDeclaracionJurada()
    }
  }

  const handleInput = (e) => {
    let { name, value, files, type } = e.target;

    setResource({...resource,
      [name]: value
    })
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Nueva Declaración Jurada <BotonVolver /></h1>
        {
          usuario && usuario.id && (
            <div className="alert alert-success" role="alert">
              Existe un usuario con este documento
            </div>
          )
        }

        <form id="carouselExample" className='carousel slide' onSubmit={handleFormSubmit}>
          <div className='carousel-inner p-3'>
            <div className='carousel-item active'>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card mb-5">
                    <div className="card-body">
                      <h5 className="card-title">Información personal</h5>
                        <div className="row mt-3">
                          <div className="col-6">
                            <TextControl
                              value={resource.cargo}
                              name={'cargo'}
                              handleInput={handleInput}
                              />
                          </div>
                          <div className="col-6">
                            <TextControl
                              value={resource.organismo}
                              name={'organismo'}
                              handleInput={handleInput}
                              />
                          </div>

                          <div className="col-6">
                            <h5>Alta norma legal</h5>
                            <TextControl
                              value={resource.f_cargo_desde}
                              name={'f_cargo_desde'}
                              label='Fecha'
                              type='date'
                              handleInput={handleInput}
                              />
                            <TextControl
                              value={resource.numero_alta_norma_legal}
                              name={'numero_alta_norma_legal'}
                              label='Número de norma legal'
                              handleInput={handleInput}
                              />
                          </div>
                          <div className="col-6">
                            <h5>Baja norma legal</h5>
                            <TextControl
                              value={resource.f_cargo_hasta}
                              name={'f_cargo_hasta'}
                              label='Fecha'
                              type='date'
                              handleInput={handleInput}
                              />
                            <TextControl
                              value={resource.numero_baja_norma_legal}
                              name={'numero_baja_norma_legal'}
                              label='Número de norma legal'
                              handleInput={handleInput}
                              />
                          </div>
                        </div>
                    </div>
                  </div>
                </div>

              </div>

              <button disabled={saving} onClick={()=>validarCampos()} className="btn btn-danger mt-3 me-3" type="button">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Verificar</span>
              </button>

              {/* <button disabled={saving} className="btn btn-primary mt-3 me-3" type="submit">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Aprobar</span>
              </button> */}
              { pdfUrl && (
                <button disabled={step===1} className="btn btn-primary mt-3" data-bs-target="#carouselExample" data-bs-slide="next" type="button">Siguiente Paso</button>
                )
              }

            </div>
            <div className='carousel-item'>
              <h5>Paso 2/2</h5>
              { pdfUrl && (
                <>
                Descargue el documento, fírmelo y adjúntelo firmado <br />
                <Link to={pdfUrl} className="btn btn-primary mt-3" target='_blank'>Descargar Documento</Link>
                <div className="mt-3 mb-3">
                  Una vez firmado, adjúntelo aquí
                  <input
                    placeholder="Adjunte el documento interactivo"
                    className="form-control"
                    onChange={handleFileChange}
                    accept='.pdf'
                    name="adjunto"
                    type="file"
                    id="adjunto" />
                </div>
                </>
                )
              }
              <hr className='mt-3 mb-3' />
              <button className="btn btn-danger mt-3 me-3" data-bs-target="#carouselExample" data-bs-slide="prev" type="button">Volver</button>

              <button disabled={saving} className="btn btn-primary mt-3" type="submit">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Finalizar</span>
              </button>

            </div>
          </div>
        </form>

        </>
      )}
    </div>
  );
};

export default DeclaracionJuradaForm;